import script from "./TaskData.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskData.vue?vue&type=script&setup=true&lang=js"

import "./TaskData.vue?vue&type=style&index=0&id=437801c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437801c1"]])

export default __exports__